"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable react/no-array-index-key */
var react_1 = __importStar(require("react"));
var ClickAwayListener_1 = __importDefault(require("@material-ui/core/ClickAwayListener"));
var MenuItem_1 = __importDefault(require("@material-ui/core/MenuItem"));
var MenuList_1 = __importDefault(require("@material-ui/core/MenuList"));
var bi_1 = require("react-icons/bi");
var GetApp_1 = __importDefault(require("@material-ui/icons/GetApp"));
var core_1 = require("@material-ui/core");
var styles_1 = require("./styles");
var Filter_svg_1 = __importDefault(require("../../../assets/svg/Filter.svg"));
var Arrow_bottom_svg_1 = __importDefault(require("../../../assets/svg/Arrow_bottom.svg"));
var excel_1 = __importDefault(require("./excel"));
var table_delete_item_svg_1 = __importDefault(require("../../../assets/svg/table-delete-item.svg"));
var table_edit_item_svg_1 = __importDefault(require("../../../assets/svg/table-edit-item.svg"));
var SelectBox_1 = __importDefault(require("./SelectBox"));
var TableCell_1 = __importDefault(require("./TableCell"));
var AllSelectBox_1 = __importDefault(require("./AllSelectBox"));
var PaginationComponentTest_1 = __importDefault(require("../PaginationComponentTest"));
/**
 * Componente para renderização dinâmica de tabelas.
 *
 * @param {IColumn} Columns Array de colunas a serem exibidas
 * @param {IRowAction} rowActions Cria uma coluna de ações permitindo interagir com a tabela
 * @param {array} getRows Retorna os dados da tabela
 * @param {boolean} selectBox Habilita o checkbox para seleção de linhas da tabela
 * @param {string} selectAllRows Permite selecionar as linhas apenas exibidas na página da tabela ou todas as linhas da tabela
 * @param {ISelectBoxActions} selectBoxActions *A propriedade selectBox deve estar definida* Ações a serem executadas com as linhas selecionadas
 * @param {IRowAction} onEditRow `Deprecated` Ações a serem executadas com as linhas selecionadas
 * @param {boolean} exportList Ativa a funcionalidade de exportação da tabela. *Default: Excel*.
 * @param exportOptions Permite a inclusão de mais possibilidades de exportação.
 * @param paginationOptions Permite customizar as opções de paginação.
 * @param onDeleteRow `Deprecated` Ações a serem executadas ao deletar as linhas selecionadas
 * @param defaultSort Recebe o nome da coluna que será utilizada como padrão para ordenação da tabela
 * @param defaultNumberOfRows Número de linhas a ser exibido ao carregar a tabela.
 * @param hidePagination Desabilita a funcionabilidade de paginação
 * @param {array} rows Array de informações que preencherão a tabela
 * @param {boolean} loading Se a tabela está em estado de carregamento
 * @param {number} defaultPage página default para exibição da tabela.
 * @param totals Habilita a linha de totais da tabela
 */
function Table(_a) {
    var _this = this;
    var columns = _a.columns, rowActions = _a.rowActions, getRows = _a.getRows, selectBoxActions = _a.selectBoxActions, onEditRow = _a.onEditRow, _b = _a.exportList, exportList = _b === void 0 ? false : _b, exportOptions = _a.exportOptions, paginationOptions = _a.paginationOptions, onDeleteRow = _a.onDeleteRow, defaultSort = _a.defaultSort, background_active = _a.background_active, defaultNumberOfRows = _a.defaultNumberOfRows, _c = _a.hidePagination, hidePagination = _c === void 0 ? false : _c, rows = _a.rows, _d = _a.selectBox, selectBox = _d === void 0 ? false : _d, selectAllRows = _a.selectAllRows, loading = _a.loading, buttons = _a.buttons, beforeExport = _a.beforeExport, _e = _a.defaultPage, defaultPage = _e === void 0 ? 0 : _e, totals = _a.totals;
    var _f = __read(react_1.useState(defaultPage), 2), page = _f[0], setPage = _f[1];
    var _g = __read(react_1.useState(defaultSort), 2), sortBy = _g[0], setSortBy = _g[1];
    var _h = __read(react_1.useState(true), 2), sortAscending = _h[0], setSortAscending = _h[1];
    var _j = __read(react_1.default.useState(false), 2), open = _j[0], setOpen = _j[1];
    var anchorRef = react_1.default.useRef(null);
    var _k = __read(react_1.default.useState(Boolean), 2), isAllSelected = _k[0], setIsAllSelected = _k[1];
    var _l = __read(react_1.default.useState(Boolean), 2), allSelected = _l[0], setAllSelected = _l[1];
    var _m = __read(react_1.useState(defaultNumberOfRows ||
        (!!paginationOptions && (paginationOptions === null || paginationOptions === void 0 ? void 0 : paginationOptions.length)
            ? paginationOptions[0].label
            : 5)), 2), rowsPerPage = _m[0], setRowsPerPage = _m[1];
    var _o = __read(react_1.useState([]), 2), selectedRows = _o[0], setSelectedRows = _o[1];
    var _p = __read(react_1.useState({}), 2), totalRow = _p[0], setTotalRow = _p[1];
    var columnsKeys = [];
    function validateTotalColumn(row, column) {
        var numberRegex = new RegExp(/\d/gi);
        if (!row[column])
            return false;
        if (row[column] === '-')
            return false;
        if (!numberRegex.test(row[column]))
            return false;
        return true;
    }
    react_1.useEffect(function () {
        if (totals) {
            var firstRow = rows[0];
            // eslint-disable-next-line no-restricted-syntax, guard-for-in
            for (var key in firstRow) {
                columnsKeys.push(key);
                // row[key] = columns.indexOf(key) !== -1 ? 0 : '-';
            }
            columnsKeys.forEach(function (column) {
                var row = totalRow;
                row[column] =
                    totals.indexOf(column) !== -1
                        ? rows.reduce(function (current, item) {
                            return validateTotalColumn(item, column)
                                ? // @ts-ignore
                                    current + Number(item[column])
                                : current;
                        }, 0)
                        : '-';
                setTotalRow(row);
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rows]);
    var updateRows = react_1.useCallback(function () {
        // setIsAllSelected(
        //   selectedRows.length ===
        //     rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).length
        // );
        if (selectAllRows === 'inTable') {
            setIsAllSelected(selectedRows.length === rows.length);
        }
        else {
            setIsAllSelected(selectedRows.length ===
                rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .length);
        }
    }, [page, rows, rowsPerPage, selectAllRows, selectedRows.length]);
    var onChangeRowsPerPage = react_1.useCallback(function (value) {
        setRowsPerPage(value);
        setPage(0);
        // setSelectedRows([]);
    }, []);
    var handleToggle = function () {
        setOpen(function (prevOpen) { return !prevOpen; });
    };
    var handleClose = function (event) {
        if (anchorRef.current &&
            anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };
    // return focus to the button when we transitioned from !open -> open
    var prevOpen = react_1.default.useRef(open);
    react_1.default.useEffect(function () {
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus();
        }
        prevOpen.current = open;
    }, [open]);
    var onChangeSort = react_1.useCallback(function (column) {
        var newSortAtribute = column.props[0].toString();
        if (newSortAtribute === sortBy) {
            setSortAscending(function (oldState) { return !oldState; });
        }
        else {
            setSortAscending(true);
        }
        setSortBy(newSortAtribute);
    }, [sortBy]);
    var dynamicSort = react_1.useCallback(function (prop) {
        var sortOrder = 1;
        var property = prop;
        if (property[0] === '-') {
            sortOrder = -1;
            property = property.substr(1);
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return function (a, b) {
            var result = 0;
            var valueA = a[property] ? a[property] : 0;
            var valueB = b[property] ? b[property] : 0;
            if (valueA < valueB) {
                result = -1;
            }
            if (valueA > valueB) {
                result = 1;
            }
            return result * sortOrder;
        };
    }, []);
    // function formatter() {
    //   const obj = document.getElementById('box');
    //   const objtr = obj.getElementsByTagName('tr');
    //   for (let i=0; i<objtr.length; i++) {
    //    if (objtr[i].cells[0].innerHTML = objtr[i].cells[1].innerHTML) {
    //      objtr[i].cells[0].rowSpan = 2;
    //    }
    //   }
    //  }
    var handleChangePage = function (event, newPage) {
        if (selectAllRows === 'perPage') {
            setPage(newPage);
            setIsAllSelected(selectedRows.includes(rows.slice(newPage * rowsPerPage, newPage * rowsPerPage + rowsPerPage)[0]));
        }
        else {
            setPage(newPage);
            setSelectedRows(selectedRows);
        }
    };
    var handleAllSelect = react_1.useCallback(function (type) {
        if (type === 'inTable') {
            setSelectedRows(selectedRows.length === 0
                ? __spread(rows) : selectedRows.length === rows.length
                ? []
                : __spread(rows));
        }
        else {
            setSelectedRows(selectedRows.length === 0
                ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                : selectedRows.length ===
                    rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .length
                    ? []
                    : rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage));
        }
    }, [page, rows, rowsPerPage, selectedRows.length]);
    var handleSelect = react_1.useCallback(function (row) {
        var index = selectedRows.findIndex(function (row_) { return row_ === row; });
        if (index >= 0) {
            selectedRows.splice(index, 1);
            setSelectedRows(selectedRows);
            updateRows();
        }
        else {
            setSelectedRows(__spread(selectedRows, [row]));
            updateRows();
        }
    }, [selectedRows, updateRows]);
    var actionHandle = react_1.useCallback(function (rowsSelected, handled, event) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            handled.onClick(rowsSelected, event);
            setSelectedRows([]);
            setAllSelected(false);
            return [2 /*return*/];
        });
    }); }, []);
    react_1.useEffect(function () {
        if (selectAllRows === 'inTable') {
            setIsAllSelected(selectedRows.length === rows.length);
        }
        else {
            setIsAllSelected(selectedRows.length ===
                rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .length);
        }
    }, [page, rows, rows.length, rowsPerPage, selectAllRows, selectedRows]);
    // useEffect(() => {
    //   console.log({ all: selectedRows });
    // }, [selectedRows]);
    if (rows.length === 0) {
        return jsx_runtime_1.jsx("p", { children: "N\u00E3o foi encontrado nenhum registro" }, void 0);
    }
    function replaceTotalLabel(column, row) {
        var obj = {};
        // eslint-disable-next-line guard-for-in
        for (var key in row) {
            obj[key] = key === column ? 'Total' : row[key];
        }
        return obj;
    }
    return (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [jsx_runtime_1.jsxs(styles_1.ActionsContainer, __assign({ className: "actionsContainer" }, { children: [beforeExport && beforeExport(), exportList && (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [jsx_runtime_1.jsx(core_1.IconButton, __assign({ ref: anchorRef, "aria-controls": open ? 'export-list' : undefined, "aria-haspopup": "true", style: selectBoxActions
                                    ? { padding: '8px', marginRight: '0.7rem' }
                                    : { padding: '8px', marginBottom: '0.7rem' }, onClick: handleToggle }, { children: jsx_runtime_1.jsx(GetApp_1.default, { color: "inherit" }, void 0) }), void 0),
                            jsx_runtime_1.jsx(core_1.Popper, __assign({ style: { zIndex: 9 }, open: open, anchorEl: anchorRef.current, role: undefined, transition: true, disablePortal: true }, { children: function (_a) {
                                    var TransitionProps = _a.TransitionProps, placement = _a.placement;
                                    return (jsx_runtime_1.jsx(core_1.Grow, __assign({}, TransitionProps, { style: {
                                            transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
                                        } }, { children: jsx_runtime_1.jsx(styles_1.List, __assign({ id: "exportListContentId", className: "exportListContent" }, { children: jsx_runtime_1.jsx(ClickAwayListener_1.default, __assign({ onClickAway: handleClose }, { children: jsx_runtime_1.jsxs(MenuList_1.default, __assign({ autoFocusItem: open, id: "export-list" }, { children: [jsx_runtime_1.jsx(MenuItem_1.default, __assign({ onClick: function () { return excel_1.default(rows, columns); } }, { children: "Excel" }), void 0), exportOptions && exportOptions()] }), void 0) }), void 0) }), void 0) }), void 0));
                                } }), void 0)] }, void 0)),
                    selectBoxActions &&
                        selectBoxActions.map(function (action, index) { return (jsx_runtime_1.jsx(jsx_runtime_1.Fragment, { children: jsx_runtime_1.jsx("button", __assign({ type: "button", className: "exportBtn", onClick: function (event) { return actionHandle(selectedRows, action, event); } }, { children: action.renderItem() }), String(index)) }, void 0)); }),
                    getRows &&
                        getRows.map(function (action, index) { return (jsx_runtime_1.jsx(jsx_runtime_1.Fragment, { children: jsx_runtime_1.jsx(core_1.ButtonBase, __assign({ type: "button", className: "exportBtn", onClick: function (event) { return action.onClick(rows, event); } }, { children: action.renderItem() }), String(index)) }, void 0)); }), buttons && buttons()] }), void 0),
            !loading && rows.length !== 0 ? (jsx_runtime_1.jsx(styles_1.Container, __assign({ className: "tableWrapperBox" }, { children: jsx_runtime_1.jsxs("table", __assign({ id: "box", className: "table-box tableBoxId" }, { children: [jsx_runtime_1.jsx("thead", { children: jsx_runtime_1.jsxs("tr", { children: [selectBox && (jsx_runtime_1.jsxs("th", __assign({ style: { padding: '7px', width: '2%' } }, { children: [selectAllRows === 'inTable' && (jsx_runtime_1.jsx(AllSelectBox_1.default, { select: isAllSelected, onClick: function () { return handleAllSelect('inTable'); } }, void 0)),
                                            selectAllRows === 'perPage' && (jsx_runtime_1.jsx(AllSelectBox_1.default, { select: isAllSelected, onClick: function () { return handleAllSelect('perPage'); } }, void 0)),
                                            !selectAllRows && (jsx_runtime_1.jsx(AllSelectBox_1.default, { select: isAllSelected, onClick: function () { return handleAllSelect('inTable'); } }, void 0))] }), void 0)), columns === null || columns === void 0 ? void 0 : columns.map(function (column) {
                                        if (column.display === 'notEmpty') {
                                            if (rows.findIndex(function (item) { return item[column.props[0]]; }) > -1) {
                                                return (jsx_runtime_1.jsx("th", __assign({ className: column.sticky ? 'sticky' : '' }, { children: jsx_runtime_1.jsx("div", __assign({ style: column.cssTitle, className: "title" }, { children: column.orderable ? (jsx_runtime_1.jsxs(styles_1.SortButton, __assign({ type: "button", onClick: function () { return onChangeSort(column); }, className: (typeof column.position === 'string'
                                                                ? column.position
                                                                : column.type === 'number'
                                                                    ? 'right'
                                                                    : null) + " icon" }, { children: [jsx_runtime_1.jsx("h1", { children: column.title }, void 0),
                                                                jsx_runtime_1.jsx("img", { style: {
                                                                        transform: "rotate(" + (sortAscending &&
                                                                            column.props[0] === sortBy
                                                                            ? '180deg'
                                                                            : 0) + ")",
                                                                        width: '15px',
                                                                    }, src: column.props[0] === sortBy
                                                                        ? Arrow_bottom_svg_1.default
                                                                        : Filter_svg_1.default, alt: column.title }, void 0)] }), void 0)) : (jsx_runtime_1.jsx("h1", { children: column.title }, void 0)) }), void 0) }), column.title));
                                            }
                                            return null;
                                        }
                                        return (jsx_runtime_1.jsx(jsx_runtime_1.Fragment, { children: column.display === false ? null : (jsx_runtime_1.jsx("th", __assign({ className: column.sticky ? 'sticky' : '' }, { children: jsx_runtime_1.jsx("div", __assign({ style: column.cssTitle, className: "title" }, { children: column.orderable ? (jsx_runtime_1.jsxs(styles_1.SortButton, __assign({ type: "button", onClick: function () { return onChangeSort(column); }, className: (typeof column.position === 'string'
                                                            ? column.position
                                                            : column.type === 'number'
                                                                ? 'right'
                                                                : null) + " icon" }, { children: [jsx_runtime_1.jsx("h1", { children: column.title }, void 0),
                                                            jsx_runtime_1.jsx("img", { style: {
                                                                    transform: "rotate(" + (sortAscending &&
                                                                        column.props[0] === sortBy
                                                                        ? '180deg'
                                                                        : 0) + ")",
                                                                    width: '15px',
                                                                }, src: column.props[0] === sortBy
                                                                    ? Arrow_bottom_svg_1.default
                                                                    : Filter_svg_1.default, alt: column.title }, void 0)] }), void 0)) : (jsx_runtime_1.jsx("h1", { children: column.title }, void 0)) }), void 0) }), column.title)) }, void 0));
                                    }), (rowActions === null || rowActions === void 0 ? void 0 : rowActions.length) || onEditRow || onDeleteRow ? (jsx_runtime_1.jsx("th", { children: jsx_runtime_1.jsx("div", __assign({ className: "title" }, { children: jsx_runtime_1.jsx("h1", { children: "A\u00E7\u00F5es" }, void 0) }), void 0) }, void 0)) : null] }, Date.now() + "theader" + Math.random()) }, void 0),
                        jsx_runtime_1.jsxs("tbody", { children: [(!hidePagination
                                    ? rows
                                        .sort(dynamicSort("" + (sortAscending ? '-' : '') + sortBy))
                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    : rows.sort(dynamicSort("" + (sortAscending ? '-' : '') + sortBy))).map(function (row, index) { return (jsx_runtime_1.jsxs("tr", __assign({ tabIndex: index }, { children: [selectBox && (jsx_runtime_1.jsx("td", __assign({ style: { padding: '7px' }, width: "2%" }, { children: jsx_runtime_1.jsx(SelectBox_1.default, { select: selectedRows.includes(row), onClick: function () { return handleSelect(row); } }, void 0) }), void 0)),
                                        columns.map(function (column, indexColumn) {
                                            if (column.display === 'notEmpty') {
                                                if (rows.findIndex(function (item) { return item[column.props[0]]; }) >
                                                    -1) {
                                                    return (jsx_runtime_1.jsx(TableCell_1.default, { column: column, row: row }, "" + String(indexColumn) + index));
                                                }
                                                return null;
                                            }
                                            if (column.display === false) {
                                                if (rows.findIndex(function (item) { return item[column.props[0]]; }) >
                                                    -1) {
                                                    return (jsx_runtime_1.jsx(TableCell_1.default, { column: column, row: row }, "" + String(indexColumn) + index));
                                                }
                                                return null;
                                            }
                                            return (jsx_runtime_1.jsx(jsx_runtime_1.Fragment, { children: jsx_runtime_1.jsx(TableCell_1.default, { column: column, row: row }, "" + String(indexColumn) + index) }, void 0));
                                        }),
                                        (!!onEditRow ||
                                            !!onDeleteRow ||
                                            (!!rowActions && !(rowActions.length === 0))) && (jsx_runtime_1.jsx("td", { children: jsx_runtime_1.jsxs("div", __assign({ className: "row-actions-item" }, { children: [onEditRow && (jsx_runtime_1.jsxs("button", __assign({ type: "button", onClick: function (event) { return onEditRow(row, event); }, className: "action" }, { children: [jsx_runtime_1.jsx("p", __assign({ className: "hover-item" }, { children: "Editar" }), void 0),
                                                            jsx_runtime_1.jsx("img", { src: table_edit_item_svg_1.default, alt: "" }, void 0)] }), void 0)),
                                                    onDeleteRow && (jsx_runtime_1.jsxs("button", __assign({ type: "button", onClick: function (event) { return onDeleteRow(row, event); }, className: "action" }, { children: [jsx_runtime_1.jsx("p", __assign({ className: "hover-item" }, { children: "Excluir" }), void 0),
                                                            jsx_runtime_1.jsx("img", { src: table_delete_item_svg_1.default, alt: "" }, void 0)] }), void 0)),
                                                    rowActions
                                                        ? rowActions.map(function (action) { return (jsx_runtime_1.jsx("button", __assign({ type: "button", onClick: function (event) { return action.onClick(row, event); }, className: "action detail" }, { children: action.renderItem(row) }), "" + (Math.random() + index))); })
                                                        : null] }), void 0) }, void 0))] }), Date.now() + index + Math.random())); }),
                                totals && (jsx_runtime_1.jsxs("tr", __assign({ tabIndex: rows.length + 1 }, { children: [selectBox && jsx_runtime_1.jsx("td", { style: { padding: '7px' }, width: "2%" }, void 0),
                                        columns
                                            // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                            .map(function (_a) {
                                            var renderItem = _a.renderItem, rest = __rest(_a, ["renderItem"]);
                                            return rest;
                                        })
                                            .map(function (column, indexColumn) {
                                            if (indexColumn === 0) {
                                                return (jsx_runtime_1.jsx(TableCell_1.default, { column: __assign(__assign({}, column), { type: 'string', position: 'left', cssProps: __assign(__assign({}, column.cssProps), { backgroundColor: '#E5E5E599' }), cssText: __assign(__assign({}, column.cssText), { fontWeight: '800', textAlign: 'left' }) }), row: replaceTotalLabel(String(column.props[0]), totalRow) }, "" + String(indexColumn) + (rows.length + 1)));
                                            }
                                            if (column.display === 'notEmpty') {
                                                if (rows.findIndex(function (item) { return item[column.props[0]]; }) >
                                                    -1) {
                                                    return (jsx_runtime_1.jsx(TableCell_1.default, { column: __assign(__assign({}, column), { position: 'right', cssProps: __assign(__assign({}, column.cssProps), { backgroundColor: '#E5E5E599' }), cssText: __assign(__assign({}, column.cssText), { fontWeight: '800', textAlign: 'right' }) }), row: totalRow }, "" + String(indexColumn) + (rows.length + 1)));
                                                }
                                                return null;
                                            }
                                            if (column.display === false) {
                                                if (rows.findIndex(function (item) { return item[column.props[0]]; }) >
                                                    -1) {
                                                    return (jsx_runtime_1.jsx(TableCell_1.default, { column: __assign(__assign({}, column), { position: 'right', cssProps: __assign(__assign({}, column.cssProps), { backgroundColor: '#E5E5E599' }), cssText: __assign(__assign({}, column.cssText), { fontWeight: '800', textAlign: 'right' }) }), row: totalRow }, "" + String(indexColumn) + (rows.length + 1)));
                                                }
                                                return null;
                                            }
                                            return (jsx_runtime_1.jsx(jsx_runtime_1.Fragment, { children: jsx_runtime_1.jsx(TableCell_1.default, { column: __assign(__assign({}, column), { position: 'right', type: 'string', cssProps: __assign(__assign({}, column.cssProps), { backgroundColor: '#E5E5E599' }), cssText: __assign(__assign({}, column.cssText), { fontWeight: '800', textAlign: 'right' }) }), row: totalRow }, "" + String(indexColumn) + (rows.length + 1)) }, void 0));
                                        }),
                                        (!!onEditRow ||
                                            !!onDeleteRow ||
                                            (!!rowActions && !(rowActions.length === 0))) && jsx_runtime_1.jsx("td", {}, void 0)] }), Date.now() + rows.length + 1 + Math.random()))] }, void 0)] }), void 0) }), void 0)) : (jsx_runtime_1.jsxs(styles_1.LoadingContainer, { children: [jsx_runtime_1.jsx(bi_1.BiLoaderAlt, { size: 48, color: "#6993FF" }, void 0),
                    jsx_runtime_1.jsx("p", { children: "Carregando..." }, void 0)] }, void 0)),
            !loading && !hidePagination ? (jsx_runtime_1.jsx("div", __assign({ className: "pagination-box", style: { paddingTop: '1rem' } }, { children: jsx_runtime_1.jsx(PaginationComponentTest_1.default, { background_active: background_active, count: rows.length, page: page, defaultNumberOfRows: defaultNumberOfRows ||
                        (!!paginationOptions && (paginationOptions === null || paginationOptions === void 0 ? void 0 : paginationOptions.length)
                            ? paginationOptions[0].label
                            : 5), options: paginationOptions || [
                        {
                            label: 5,
                            value: 5,
                        },
                        {
                            label: 10,
                            value: 10,
                        },
                        {
                            label: 25,
                            value: 25,
                        },
                        {
                            label: 50,
                            value: 50,
                        },
                        {
                            label: 100,
                            value: 100,
                        },
                    ], onChangeRowsPerPage: onChangeRowsPerPage, 
                    // eslint-disable-next-line @typescript-eslint/no-empty-function
                    onChangePage: handleChangePage, rowsPerPage: rowsPerPage }, void 0) }), void 0)) : null] }, void 0));
}
exports.default = Table;
//# sourceMappingURL=index.js.map